/**
 * シフト枠ステータス
 *
 * 遷移フロー:
 *   draft → fixed_recruiting → fixed_closed → fixed_confirmed → recruiting → closed → confirmed
 *
 * fixed_recruiting / fixed_closed / fixed_confirmed は「固定シフト（医師シフトルール由来）」の
 * 反映～締切～部分確定を表す中間状態。draft から通常募集へ直接進むフローも維持する。
 */
export type ShiftSlotStatus =
  | 'draft'             // 下書き
  | 'fixed_recruiting'  // 固定シフト募集中
  | 'fixed_closed'      // 固定シフト締切
  | 'fixed_confirmed'   // 固定シフト確定済み
  | 'recruiting'        // 募集中
  | 'closed'            // 締切
  | 'confirmed';        // 確定

/**
 * ステータス表示ラベル
 */
export const SHIFT_SLOT_STATUS_LABELS: Record<ShiftSlotStatus, string> = {
  draft: '設定中',
  fixed_recruiting: '固定シフト募集中',
  fixed_closed: '固定シフト締切',
  fixed_confirmed: '固定シフト確定済',
  recruiting: '募集中',
  closed: '締切',
  confirmed: '確定',
};
